import React from 'react'
import Wrapper from './style'

const FullWidthWrapper = ({className, children}) => {
	return (
		<Wrapper className={className}>
			{children}
		</Wrapper>
	)
}

export default FullWidthWrapper